import $ from 'jquery';

angular.module("SupportAgent")
.controller(
 'TabRemoteSecurityController',
 ['$rootScope', '$scope', '$filter', 'EventHandler', '$timeout',
  'INTERACT','L','PERSISTENCE',
 function ($rootScope, $scope, $filter, EventHandler,$timeout,INTERACT,L,PERSISTENCE) {
  var EVALUATION_PROBLEM = 4;
  var EVALUATION_OK = 2;
  var TEST_SECURITY_UNKNOWNSOURCES = 126;
  var TEST_SECURITY_APPVERFICATION = 127;
  var TEST_SECURITY_VISIBLEPASSWORD = 128;
  var secTestEvent = {
   RemoteLocate:"1", RemoteAlert:"2", RemoteLock:"3", RemoteWipe:"5", RemotePicture:"6", RemoteScreenshot:"7"};
  var map = undefined;
  var marker = undefined;
  var positionLat = null;
  var positionLng = null;
  $rootScope.conStatus = false;
  $scope.showcountdown = false;
  $(document).ready(function(){
   $('[data-toggle="tooltip"]').tooltip();
  });
  $scope.launchTest = function (testName) {
   var acid = $rootScope.getAccountID($rootScope.conversationID);
   var account = INTERACT.get_account(acid);
   if($rootScope.isTestRequestPending(121,account.d[account.sd].id)&&(testName=="RemotePicture")) {
    $("#remote-photo").modal();
    return ;
   }
   EventHandler.APILAYER.sendMessage({
    convid: account.dcid, channelid: INTERACT.D.xaction.channel.diagreq,
    msg: "3|"+secTestEvent[testName],
    devid: account.d[account.sd].id
   });
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: acid,
    display_name: "",
    msg: $rootScope.strings.str_diagnostic_request+testName,
    msgtime: new Date(),
    channelid: 3, // TODO: magic
    convstatus: 1 // TODO: magic
   });
   if(testName=="RemotePicture")
    $rootScope.SecurityTests.push({acid:acid,did:account.d[account.sd].id,tid:121,time:new Date()});
  };
  $scope.$on('onUpdateImageGallery', function (event,images,did) {
   $scope.galleryArray = [];
   for(var fid in images["did"+did]) {
    var image = {"thumb":images["did"+did][fid], "img":images["did"+did][fid]};
    $scope.galleryArray.push(image);
   }
   $timeout(function() {
    $scope.$apply();
   }, 0);
  });
  var setMarkerLastPosition = function() {
   if(!(map && positionLat && positionLng)) return;
   var image = {
    url:'img/device-location.svg',
    size:new google.maps.Size(60, 60)
   };
   if(marker == undefined)
    marker = new google.maps.Marker({
     position: new google.maps.LatLng(positionLat, positionLng),
     map: map,
     icon: image,
     animation: google.maps.Animation.DROP
    });
   else marker.setPosition(new google.maps.LatLng(positionLat, positionLng));
   map.setCenter(marker.getPosition());
   var latlngbounds = new google.maps.LatLngBounds();
   latlngbounds.extend(marker.getPosition());
   map.fitBounds(latlngbounds);
   map.setZoom(Math.min(map.getZoom()-1,16));
  };
  $scope.resizeMap = function(id) {
   //Initialize Map
   if(map == undefined)
    map=new google.maps.Map(
     document.getElementById(id),{zoom: 2, center: new google.maps.LatLng(28.755, 2.7139)});
   //Resize of the map once ensured it is loaded & displayed
   google.maps.event.trigger(map, 'resize');
   //Show last position if available
   setMarkerLastPosition();
  };
  $scope.$on('showDeviceLocation' , function (event,lat,lng) {
   positionLat = lat;
   positionLng = lng;
   L.trace({lat:positionLat,lon:positionLng},"Stored new location: " + positionLat + "," + positionLng);
   setMarkerLastPosition();
  });
  $scope.triggerMapResize = function() {
   setTimeout(function() { if($("#locate-device-tab").is(":visible")) $scope.resizeMap(); }, 100);
  };
  $scope.remoteEvents = function () {
   if ($scope.userChoice == 'drawing')
    $scope.sendDrawingMode('0xffc4');
   else {
    $scope.sendDrawingMode('0xffc5');
    $scope.sendDrawingMode('0xffc4');
   }
  };
  $scope.sendDrawingMode = function(id) {
   return $rootScope.sendButtonKeyEvent(id);
  };
  $scope.disConnect = function() {
   EventHandler.stopRemote();
   $rootScope.conStatus = false;
   $scope.userChoiceRemote = "none";
   $rootScope.remoteConnection = {};
   $rootScope.enableRemoteButton();
   $rootScope.remoteConnection.connected=false;
  };
  $scope.settingsApply = function() {
   PERSISTENCE.put(
    ['encrypt','true_color','cursor','shared','view_only'].map(function(x) {
     var k = 'noVNC_'+x; return {key:k,data:$D(k).checked};
    }).concat(['resize','encodeProtocol'].map(function(x) {
     var k = 'noVNC_'+x; return {key:k,data:$(k).value};
    }))
   );
   $D('noVNC_settings').style.display = "none";  
  };
  $scope.showSettings = function() {
   var got = PERSISTENCE.get({
    noVNC_encrypt: false,
    noVNC_true_color: true,
    noVNC_cursor: true,
    noVNC_shared: true,
    noVNC_view_only: false,
    noVNC_resize: 'remote',
    noVNC_encodeProtocol: 'tight'
   });
   ['encrypt','true_color','cursor','shared','view_only'].forEach(function(x) {
    var k = 'noVNC_'+x; $D(k).checked = got[k];
   });
   ['resize','encodeProtocol'].forEach(function(x) {
    var k = 'noVNC_'+x; $D(k).value = got[k];
   });
   $D('noVNC_screenInfo').style.display = "none";
   $D('noVNC_settings').style.display = "block";
  };
  $scope.screenInfo = function() {
   $D('noVNC_settings').style.display = "none";
   $D('noVNC_screenInfo').style.display = "block";
   $("#desktopGeometry").html( $D('noVNC_canvas').offsetWidth + " X " + $D('noVNC_canvas').offsetHeight);
  };
  $scope.closescreenInfo = function() {
   $D('noVNC_screenInfo').style.display = "none";
  };
  $rootScope.isTestRequestPending = function(tid,did) {
   var index = $rootScope.SecurityTests.indexOf(
    $filter('filter')($rootScope.SecurityTests, {did:did,tid:tid}, true)[0]);
   if(index == -1) return false;
   // TODO: ideally, we should store expiration time once instead of adding a
   // timeout every time
   if( (+$rootScope.SecurityTests[index].time+60000) > +new Date() ) {
    $rootScope.SecurityTests.splice(index,1);//removing old entry as it is expired
    return false;
   }
   return true;
  };
  $scope.refreshSecurityInfoTests = function(){
   if(!$rootScope.isDiagTestReady($rootScope.conversationID)) return;
   $rootScope.checkAndRunSecurityInfoTests("",true);
  };
  $rootScope.findTestResult = function(testID, results) {
   var index = results.indexOf($filter('filter')(results, {tid: testID})[0]);
   return results[index];
  };
  $rootScope.checkAndRunSecurityInfoTests = function(results,run) {
   var account = INTERACT.get_account($rootScope.accountID);
   var testAvailable = false;
   if(!run) {
    var result = $rootScope.findTestResult(TEST_SECURITY_UNKNOWNSOURCES,results);
    if(result) {
     testAvailable = true;
     $rootScope.securityPolicies.timestamp = $rootScope.ISO8601DateFormat(result.ts);
     $rootScope.securityPolicies.unknownSources = (result.te==EVALUATION_PROBLEM);
     result = $rootScope.findTestResult(TEST_SECURITY_APPVERFICATION,results);
     if(result) $rootScope.securityPolicies.appVerfication = (result.te==EVALUATION_OK);
     result = $rootScope.findTestResult(TEST_SECURITY_VISIBLEPASSWORD,results);
     if(result) $rootScope.securityPolicies.visiblePassword = (result.te==EVALUATION_PROBLEM);
    }
   }
   if(!testAvailable) {
    if($rootScope.isHidden("securityinfotest")) return;
    EventHandler.APILAYER.sendMessage( {
     convid: account.dcid,
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg: $rootScope.testPayload.policiesInfo,
     devid: account.d[account.sd].id
    });
    $rootScope.appendMessageToHistory({
     convid: $rootScope.conversationID, acid: $rootScope.accountID,
     msg: $rootScope.strings.str_diagnostic_request+$rootScope.strings.str_security_policies,
     msgtime: new Date(),
     channelid: 3 // TODO: magic
    });
   }
  };
  $rootScope.checkAndRunLocationTest = function(results,run) {
   var testAvailable = false;
   if(!run) {
    var index = results.indexOf($filter('filter')(results, {tid: 117,te:2},true)[0]);
    if(index==-1) index = results.indexOf($filter('filter')(results, {tid: 117},true)[0]);
    var lat,lng;
    if(index!=-1) {
     var result = results[index];
     $rootScope.securityPolicies.locationTS = $rootScope.ISO8601DateFormat(result.ts);
     testAvailable = true;
     lat = getValueFromResult(result.trd,"lat");
     if(lat) { // get values from test result data
      lng = getValueFromResult(result.trd,"long");
     }
     else {
      if(!result.tc||result.tc.indexOf(",",0)==-1) return;
      var split = result.tc.split(', ');
      lat = split[0];
      lng = split[1];
     }
     $rootScope.$broadcast("showDeviceLocation",lat,lng);
    }
   }
   if(!testAvailable) {
    if($rootScope.isHidden("locationtest")) return;
    EventHandler.APILAYER.sendMessage({
     convid: $rootScope.conversationID,
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg: "3|1", // TODO: magic
     devid: $rootScope.deviceID
    });
    $rootScope.appendMessageToHistory({
     convid: $rootScope.conversationID, acid: $rootScope.accountID,
     msg: $rootScope.strings.str_diagnostic_request+$rootScope.strings.str_locate_device,
     msgtime: new Date(),
     channelid: 3 // TODO: magic
    });
   }
  };
  $scope.refreshLocationInfo = function(){
   if(!$rootScope.isDiagTestReady($rootScope.conversationID)) return;
   $rootScope.checkAndRunLocationTest("",true);
  };
  $rootScope.onRemote = function() {
   if(!$rootScope.conStatus) {
    $scope.startRemoteConnection = false;
    if(!$rootScope.remoteConnection.connected) $scope.startRemoteConnection = true;
    else if(($rootScope.remoteConnection.acid!=$rootScope.accountID)||
            ($rootScope.remoteConnection.did!= $rootScope.deviceID)) {
     $rootScope.remoteConnection.connected=false;
     $timeout(function() {
      $rootScope.$apply();
     }, 0);
     $scope.startRemoteConnection = true;
    }
    if($scope.startRemoteConnection) {
     EventHandler.APILAYER.sendMessage({
      convid: $rootScope.conversationID,
      channelid: INTERACT.D.xaction.channel.remote,
      msg: "Remote request initiated",
      devid:$rootScope.deviceID
     });
     $scope.startRemote();
     $rootScope.remoteConnection.acid = $rootScope.accountID;
     $rootScope.remoteConnection.did = $rootScope.deviceID;
     var profile = INTERACT.get_account(+$rootScope.accountID).pr;
     $rootScope.remoteConnection.name = profile.first_name+" "+profile.last_name;
     $scope.userChoiceRemote = "eventinj";
    }
   }
   else {
    $scope.disConnect();
   }
  };
  $scope.startRemote = function() {
   $scope.showcountdown = true;
   $scope.countdown = 30;
   L.trace('startRemote');
   $scope.disable = true;
   EventHandler.startRemote($rootScope.accountID, $rootScope.deviceID);
   $scope.timer = setInterval(function(){$scope.countdown--;$scope.$apply()},1000);
   $scope.remoteTimeout = $timeout(function() {
    $rootScope.remote_error_message = "the request has timed out. please check whether the device is online and user has accepted the request";
    $('#remote-fail-modal').modal();
    $rootScope.enableRemoteButton();
   }, 30000);
  };
  $rootScope.enableRemoteButton = function() {
   $scope.showcountdown = false;
   $scope.disable = false;
   clearInterval($scope.timer);
   $timeout.cancel($scope.remoteTimeout);
   if($rootScope.conStatus) $scope.disConnect();
   $timeout(function() {
    $scope.$apply();
   }, 0);
  };
  function getValueFromResult(res, entry) {
   if(!res) return "";
   res = JSON.parse(res);
   return (res.hasOwnProperty(entry) && String(res[entry]))||"";
  }
  $rootScope.initialize_map = function(id) {
   map=marker=undefined;
   positionLat=positionLng= null;
   $scope.resizeMap(id);
  };
}]);
/* vim:set ts=8 sw=1 expandtab: */
